import { Component } from "react";
import PropTypes from "prop-types";
import Alert from "@material-ui/lab/Alert";
import Snackbar from "@material-ui/core/Snackbar";

let openSnackbarFn;

class SnackBarCustom extends Component {
  state = {
    open: false,
    message: "",
  };

  componentDidMount() {
    openSnackbarFn = this.openSnackBar;
  }

  openSnackBar = ({ message }) => {
    this.setState({ open: true, message });
  };

  handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    this.setState({ open: false, message: "" });
  };

  render() {
    return (
      <Snackbar
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        open={this.state.open}
        autoHideDuration={6000}
        onClose={this.handleClose}
      >
        <Alert severity={this.props.variant}> {this.state.message}</Alert>
      </Snackbar>
    );
  }
}

SnackBarCustom.propTypes = {
  classes: PropTypes.object,
  className: PropTypes.string,
  message: PropTypes.node,
  onClose: PropTypes.func,
  variant: PropTypes.oneOf(["success", "warning", "error", "info"]).isRequired,
};

export function openSnackbar(message) {
  openSnackbarFn({ message });
}

export default SnackBarCustom;
